import {ILaboratoireWebServiceClient} from "./../../../../../common/resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {StatutDossierEnums} from "@common/enum/StatutDossier.enum";
import {Component, Input} from "@angular/core";
import {DossierDto} from "@resources/resources";
import {TranslateService} from "@ngx-translate/core";
import { CorrespondantStore } from "@digicerba/common";

@Component({
  selector: 'entete-detail-resultat',
  templateUrl: './entete-detail-resultat.component.html'
})
export class EnteteDetailServeurResultatsComponent {

  @Input() dossier: DossierDto;

  infoLaboratoire: string = "";

  constructor(private router: Router,
              private activateRoute: ActivatedRoute,
              private correspondantStore: CorrespondantStore,
              private laboratoireService: ILaboratoireWebServiceClient,
              private translateService: TranslateService) {
  }

  goToDossierAntecedent() {
    this.router.navigate(['../', this.dossier.idDossierAntecedent], { relativeTo: this.activateRoute });
  }

  ngOnChanges() {
    this.initLaboratoire();
  }

  private initLaboratoire() {
    this.laboratoireService.findByIdentifiants([this.dossier.identifiantLabo]).subscribe(labo =>
      this.infoLaboratoire = labo[0] ? labo[0].nomCompagnie : null
    );
  }

  isDossierComplet() {
    return this.dossier.statutDossier == StatutDossierEnums.TERMINE.value() ||
      this.dossier.statutDossier == StatutDossierEnums.VALIDE_COMPLET.value();
  }

  isDossierPartiel() {
    return this.dossier.statutDossier == StatutDossierEnums.VALIDE_PARTIEL.value();
  }

  getDisplayIdentity() {
    let identity = "";
    if (this.dossier.prenomPatient != null) {
      identity += this.dossier.prenomPatient  + " " ;
    }

    if (this.dossier.nomPatient != null) {
      identity += this.dossier.nomPatient;
    }

    if (this.dossier.nomJeuneFillePatient != null && this.dossier.nomJeuneFillePatient != "") {
      identity += this.translateService.instant("PAGE.SERVEUR-RESULTATS.neeLe");
      identity += this.dossier.nomJeuneFillePatient;
    }

    return identity;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/entete/entete-detail-resultat.component.ts